// Sound management utilities

export type SoundName = 'migo' | 'yugo' | 'igo' | 'wego';

const SOUND_VOLUMES: Record<SoundName, number> = {
  migo: 0.3,
  yugo: 0.3,
  igo: 0.168, // Reduced volume for igo sound
  wego: 0.3
};

/**
 * Plays a sound effect if sound is enabled
 * @param soundName - The name of the sound to play ('migo', 'yugo', 'igo', or 'wego')
 * @param soundEnabled - Whether sound effects are enabled
 */
export const playSound = (soundName: SoundName, soundEnabled: boolean): void => {
  if (!soundEnabled) {
    return;
  }

  try {
    const audio = new Audio(`/sounds/${soundName}.mp3`);
    audio.volume = SOUND_VOLUMES[soundName];
    audio.play().catch(() => {
      // Sound play failed - silently fail
    });
  } catch (e) {
    // Sound loading failed - silently fail
  }
};

/**
 * Plays the illegal move sound effect if sound is enabled
 * @param soundEnabled - Whether sound effects are enabled
 */
export const playIllegalMoveSound = (soundEnabled: boolean): void => {
  if (!soundEnabled) return;
  try {
    const audio = new Audio('/sounds/illegal-move.mp3');
    audio.volume = 0.5;
    audio.play().catch(() => {});
  } catch (e) {
    // Silently fail
  }
};

